import { Component, Inject, OnInit } from '@angular/core';
import { SelectOption } from '@maids/cc-lib/select-input';
import { CCThemeService, CC_AVAILABLE_THEMES } from '@maids/cc-lib/theme';
import { Observable, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AppService } from './app-services';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { CCNotificationService } from '@maids/cc-lib/services';
import { CCAuthService } from '@maids/cc-erp-services';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  environment = environment;

  title = 'main-angular';

  links: any = {
    type: 'main',
    children: [],
  };
  userlinks: any = {
    type: 'main',
    children: [],
  };
  menu$!: Observable<any>;
  userMenu$!: Observable<any>;
  canEdit = false;
  user: any;
  currentRoute: string = '';
  showEditMenu: boolean = false;


  showLayout = true;
  constructor(
    private _service: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private _notificationService: CCNotificationService,
    private _themeService: CCThemeService,
    private _authService: CCAuthService,
    @Inject(CC_AVAILABLE_THEMES) public readonly themes: CC_AVAILABLE_THEMES
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        const urlTree = this.router.parseUrl(event.urlAfterRedirects);
        this.showEditMenu = !!(urlTree.queryParams && urlTree.queryParams['edit-menu'] === 'true');
      }
    });
  }
  pageCodes$!: Observable<SelectOption[]>;
  ngOnInit(): void {
    this.checkAndApplyDarkMode();

    this._themeService.loadThemeByName('cc-sunrise', 'light');
    // Initialize strictly from the current URL's query param
    this.showEditMenu = this.route.snapshot.queryParamMap.get('edit-menu') === 'true';
    this._authService.loggedUser$.subscribe((user) => {
      this.user = user;
    });

    // Initialize userMenu$ observable
    //this.userMenu$ = this._service.fetchUserMenu();
  }

  saveMenu(data: any) {
    this._service.saveMenu(data).pipe(
      tap(() => {
        this._notificationService.notifySuccess('Updated Successfully');
        this.showLayout = false;
      }),
      switchMap(() => timer(10)),
      tap(() => {
        this.showLayout = true;
      }),
      // Fetch fresh menu data
      // switchMap(() => this._service.fetchUserMenu()),
      // tap((response) => {
      //   // Update local data
      //   this.userlinks.children = response;
      // })
    ).subscribe();
  }

  isLoginPage(): boolean {
    // Check if current route is login
    if (this.currentRoute.includes('login')) {
      return true;
    }

    // For empty route, check if user is authenticated
    if (this.currentRoute === '' || this.currentRoute === '/') {
      // Use getCurrentUser to check authentication state
      return !this.user; // Show login if no user
    }

    return false;
  }
  private readonly DARK_MODE_STORAGE_KEY = 'cc_dark_mode_preference';

  /**
   * Get dark mode preference from localStorage (managed by cc-lib)
   */
  private getDarkModePreference(): boolean {
    const preference = localStorage.getItem(this.DARK_MODE_STORAGE_KEY);
    return preference === 'true';
  }

  /**
   * Apply dark mode CSS classes to the document
   */
  private applyDarkModeCSS(isDarkMode: boolean): void {
    const body = document.body;
    const html = document.documentElement;

    if (isDarkMode) {
      body.classList.add('dark-mode');
      html.classList.add('dark-mode');
    } else {
      body.classList.remove('dark-mode');
      html.classList.remove('dark-mode');
    }
  }

  /**
   * Check localStorage and apply dark mode CSS accordingly
   */
  private checkAndApplyDarkMode(): void {
    const isDarkMode = this.getDarkModePreference();
    this.applyDarkModeCSS(isDarkMode);
  }

  handleDarkMode(isDarkMode: any): void {
    this.checkAndApplyDarkMode();
  }


}
